import type { FaireCollectionEntity } from "../../entity_types/collection";

export const pbc_53kzvakd4r: FaireCollectionEntity = {
  token: "pbc_53kzvakd4r",
  type: "collection",
  name: "FESTIVAL",
  heroImageUrl:
    "https://cdn.faire.com/fastly/707e1d6d5655e47e39d6e9b31819bb984ec2e8e42dfa0be0f477326c8fd20d23.jpeg",
  itemCount: 7,
  description:
    "Unleash your wild side with our festival boots! From suede knee-highs to chunky-heeled ankle cowgirl boots, we're blending festival flair with Western chic.\nFor styling tips or an exclusive look at new styles, check out our socials IG: @_lemonadeshoes or TIKTOK: @lemonadeshoes",
  brandToken: "b_mz3xxxsvnf",
  productTokens: [],
  meta: {
    source: "api",
    importedAt: "2026-08-13T23:39:30.606Z",
    importedBy: "entity-db-import-collections",
  },
};
